export const heightList = [
  {Id: 1, Name: '4ft 5in - 135cm'},
  {Id: 2, Name: '4ft 6in - 137cm'},
  {Id: 3, Name: '4ft 7in - 140cm'},
  {Id: 4, Name: '4ft 8in - 142cm'},
  {Id: 5, Name: '4ft 9in - 145cm'},
  {Id: 6, Name: '4ft 10in - 147cm'},
  {Id: 7, Name: '4ft 11in - 150cm'},
  {Id: 8, Name: '5ft 0in - 152cm'},
  {Id: 9, Name: '5ft 1in - 155cm'},
  {Id: 10, Name: '5ft 2in - 157cm'},
  {Id: 11, Name: '5ft 3in - 160cm'},
  {Id: 12, Name: '5ft 4in - 163cm'},
  {Id: 13, Name: '5ft 5in - 165cm'},
  {Id: 14, Name: '5ft 6in - 168cm'},
  {Id: 15, Name: '5ft 7in - 170cm'},
  {Id: 16, Name: '5ft 8in - 173cm'},
  {Id: 17, Name: '5ft 9in - 175cm'},
  {Id: 18, Name: '5ft 10in - 178cm'},
  {Id: 19, Name: '5ft 11in - 180cm'},
  {Id: 20, Name: '6ft 0in - 183cm'},
  {Id: 21, Name: '6ft 1in - 185cm'},
  {Id: 22, Name: '6ft 2in - 188cm'},
  {Id: 23, Name: '6ft 3in - 190cm'},
  {Id: 24, Name: '6ft 4in - 193cm'},
  {Id: 25, Name: '6ft 5in - 196cm'},
  {Id: 26, Name: '6ft 6in - 198cm'},
  {Id: 27, Name: '6ft 7in - 201cm'},
  {Id: 28, Name: '6ft 8in - 203cm'},
  {Id: 29, Name: '6ft 9in - 206cm'},
  {Id: 30, Name: '6ft 10in - 208cm'},
  {Id: 31, Name: '6ft 11in - 210cm'},
  {Id: 32, Name: '7ft 0in - 213cm'},
];
